<template lang="pug">
.h-vertical-align-container(v-show='embedShow')
  .embed-popup__overlay.fadeIn(@click='close()')
  .modal__wrapper
    .embed-popup.fadeInDown
      .embed__popup--container
        .modal__close.embed__close(@click='close()')
        span.ready.fadeInDownEmbed.embed_copy(v-if='isCopied')
          img(src='https://cdn.flixel.com/static/static-web/misc/embed_copy.png')

        .embed__popup--item.embed--radio
          .ui-input.ui-input--radio
            input(type='radio',
              value='responsive'
              v-model='sizing')
            label Responsive

          .ui-input.ui-input--radio
            input(type='radio',
              value='fixed'
              v-model='sizing')
            label Fixed

        .embed__popup--item
          .ui-input(v-if='sizing === "fixed"')
            select(name='sizeSelector', v-model='customSize.type', @change='updateCustom')
              option(value='custom') Custom Size
              option(value='small') {{ resizer.small.width }} X {{ resizer.small.height }}
              option(value='medium') {{ resizer.medium.width }} X {{ resizer.medium.height }}
              option(value='large') {{ resizer.large.width }} X {{ resizer.large.height }}

            div.custom-size-embed(v-if='customSize.type === "custom"')
              input.small-input-hack(type='text', v-model='customSize.width', v-on:input='changeWidth(customSize.width)')
              span.custom-size-x x
              input.small-input-hack(type='text', v-model='customSize.height', v-on:input='changeHeight(customSize.height)')

        .embed__popup--item
          .ui-input
            input(type='checkbox', v-model='queryParams.useHd')
            label Use HD

        .embed__popup--item.embed__popup--desc
          p Cinemagraphs are short videos. Most mobile and web browsers can only play a few videos on one page at the same time. If you embed more, please use caution and test

        .embed__popup--item.embed__popup--embedCode
          p Embed Code
          .ui-input(@click="clickTextArea()")
            textarea.embed_url(
            v-if="sizing !== 'responsive'",
            type='text',
            readonly='readonly',
            resize='none',
            wrap="off",
            value='')
              | <div class="flx-embed"><iframe width="{{ customSize.width }}" height="{{ customSize.height }}" src="{{ flixel.embed_url }}?hd={{ queryParams.useHd }}" frameborder="0" allowfullscreen allow='autoplay'></iframe></div>

            textarea.embed_url(
            v-if="sizing === 'responsive'",
            type='text',
            readonly='readonly',
            wrap="off",
            value='')
              | <div class="flx-embed"><div style="position:relative; height:0; padding-bottom:{{ resizer.responsive.paddingBottom }}%; width:100%"><iframe style="position:absolute; top:0; left:0; width:100%; height:100%;" src="{{ flixel.embed_url }}?hd={{ queryParams.useHd }}" frameborder="0" allowfullscreen allow='autoplay'></iframe></div></div>
          p Copy this code to embed on your website

          a.btn.btn--blue(@click='copyToClipboard()') Embed Code
</template>

<script>
import FlixelService from 'services/flixel.es6.js';
import EventBus from '../eventBus.js';

export default {
  name: 'Embed-Popup',
  props: ['embed', 'flixel'],
  data() {
    return {
      width: '',
      height: '',
      aspect: '',
      embedShow: false,
      isCopied: false,
      sizing: 'responsive',
      customSize: {
        type: 'large',
        width: '1920',
        height: '1080',
      },
      queryParams: {
        useHd: false,
        forceGif: false,
      },
      resizer: {
        small: '',
        medium: '',
        large: '',
        responsive: {
          paddingBottom: 56.25,
        },
      },
    };
  },
  created() {
    const self = this;
    EventBus.$on('openEmbed', function () {
      self.height = self.flixel.height;
      self.width = self.flixel.width;
      self.aspect = self.width / self.height;
      self.resizer.small = FlixelService.fixedSize(self.width, self.height, 50);
      self.resizer.medium = FlixelService.fixedSize(self.width, self.height, 70);
      self.resizer.large = FlixelService.fixedSize(self.width, self.height, 100);
      self.resizer.responsive = FlixelService.responsive(self.flixel.width, self.flixel.height);
      self.embedShow = true;
    });
  },
  methods: {
    updateCustom(e) {
      const selected = e.target.value;
      if (selected === 'custom') {
        this.customSize.type = 'custom';
      } else {
        this.customSize = this.resizer[selected];
        this.customSize.type = selected;
      }
    },
    changeHeight(newHeight) {
      this.customSize.width = (newHeight*this.aspect).toFixed();
    },
    changeWidth(newWidth) {
      this.customSize.height = (newWidth*this.aspect).toFixed();
    },
    copyToClipboard() {
      $('.embed-popup textarea').select();
      try {
        // Now that we've selected the anchor text, execute the copy command
        if (document.execCommand('copy')) {
          this.changeCopiedState();
        }
      } catch (err) {
        console.log('Oops, unable to copy');
      }
    },

    changeCopiedState() {
      this.isCopied = true;
      window.setTimeout(function () {
        this.isCopied = false;
      }, 3000);
    },

    clickTextArea() {
      $('.embed-popup textarea').select();
    },

    close() {
      this.embedShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/EmbedPopup.vue